import _asyncToGenerator from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          Bugsnag.start({
            notifyReleaseStages: ['production'],
            apiKey: '500a1d8cc37986b1864baa8364d0fae9',
            appType: 'client',
            appVersion: '1.0.3',
            plugins: [new BugsnagPluginVue()]
          });
          Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();